import React from 'react'
import ReactGA from 'react-ga'
import { useHistory } from 'react-router-dom'
import { SkeletonTheme } from 'react-loading-skeleton'

import Card from '../../../components/Card'
import LoadMore from '../../../components/LoadMore'
import { formatDate } from '../../../utils/formatters'
import { FaChevronRight } from 'react-icons/fa'
import { LIMIT, notificationTypes } from './constants'
import { useGetNotifications } from '../../../hooks/useGetNotifications'
import envelopeGray from '../../../assets/icons/envelope-gray.svg'
import Alert from '../../../components/Form/Alert'
import LoadingCards from './components/LoadingCards'

import * as S from './styles'

const Notifications = () => {
  const history = useHistory()
  const { professional, partner } = JSON.parse(localStorage.getItem('userData'))
  const professionalId = professional.id
  const partnerId = partner

  const { notifications, totalNotifications, loading, handleGetNotificationByProfessionalId } = useGetNotifications({ LIMIT })

  const shouldShowLoadMore = () => loading ? false : totalNotifications > notifications?.length && notifications.length > 0

  const goToPage = (url) => {
    history.push(`/${url}`)
    ReactGA.pageview(`/${url}`)
  }

  const loadMore = () => {
    return <LoadMore
      show={shouldShowLoadMore()}
      handleGetData={handleGetNotificationByProfessionalId}
      LIMIT={LIMIT}
    />
  }

  const renderNotification = (notification, index) => {
    const partnerData = notification.partners.find(partner => partner.partner === partnerId && partner.professionals)
    const professionalData = partnerData.professionals.find(prof => prof.professional === professionalId)
    const isRead = professionalData?.read
    const isNotAccepted = !professionalData?.accepted
    const isOfficial = notification?.notificationType === 'OFFICIAL'

    return (
      <S.StyledCard key={`${notification.id}-${index}`} onClick={() => goToPage(`notification-details/${notification.id}`)}>
        <Card full >
          <S.Avatar src={isRead ? envelopeGray : notificationTypes[notification.notificationType].avatar} alt="envelope-avatar" />
          <S.TextBlock>
            {(isNotAccepted && isOfficial && isRead) &&
              <S.WarningLabel>
                <S.WarningText> Confirmação pendente</S.WarningText>
              </S.WarningLabel>
            }
            <S.Subtitle isRead={isRead}>{notification.name}</S.Subtitle>
            <S.Text isRead={isRead}>{notification.message}</S.Text>
            <S.DateField>{formatDate({ date: notification.createdAt, capitalizeMonth: true })}</S.DateField>
          </S.TextBlock>
          <S.ButtonOpen onClick={() => goToPage(`notification-details/${notification.id}`)}>
            <FaChevronRight size='21' color={isRead ? '#777' : notificationTypes[notification.notificationType].color} />
          </S.ButtonOpen>
        </Card>
      </S.StyledCard>
    )
  }

  return (
    <SkeletonTheme baseColor="#D9D9D9">
      <S.Container>
        <S.List>
          <S.Title>Avisos e comunicados</S.Title>
          <Alert show={!notifications.length && !loading}>
            Nenhum aviso ou comunicado até o momento.
          </Alert>
          {loading
            ? <LoadingCards />
            : notifications.map((item, index) => {
              return renderNotification(item, index)
            })}
          {loadMore()}
        </S.List>
      </S.Container>
    </SkeletonTheme>
  )
}

export default Notifications
